import { NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-checklist-item',
  standalone: true,
  imports: [LucideAngularModule, RouterLink, NgTemplateOutlet],
  template: `
    @if (route(); as r) {
      <a
        [routerLink]="r"
        class="group flex items-center gap-2 py-1.5 rounded-md px-1 -mx-1 transition-colors hover:bg-[var(--bg-hover)]"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    } @else {
      <div class="flex items-center gap-2 py-1.5">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    }

    <ng-template #content>
      <span
        class="inline-flex h-4 w-4 items-center justify-center transition-all duration-200"
        [class.scale-110]="done()"
        [class.text-[var(--success)]]="done()"
        [class.text-[var(--muted)]]="!done()"
      >
        <lucide-icon
          [name]="done() ? 'check-circle-2' : 'circle'"
          [size]="16"
          aria-hidden="true"
        ></lucide-icon>
      </span>
      @if (iconName()) {
        <span
          class="inline-flex h-4 w-4 items-center justify-center transition-colors duration-200"
          [class.text-[var(--muted)]]="done()"
          [class.opacity-60]="done()"
          [class.text-[var(--text-muted)]]="!done()"
        >
          <lucide-icon [name]="iconName()!" [size]="14" aria-hidden="true"></lucide-icon>
        </span>
      }
      <span
        class="text-[12.5px] leading-tight transition-colors duration-200"
        [class.text-[var(--muted)]]="done()"
        [class.line-through]="done()"
        [class.opacity-70]="done()"
        [class.text-[var(--text)]]="!done()"
      >
        {{ label() }}
      </span>
    </ng-template>
  `,
})
export class ChecklistItemComponent {
  done = input<boolean>(false);
  label = input<string>('');
  iconName = input<string | null>(null);
  route = input<readonly unknown[] | null>(null);
}
